module fdm.performedLegs {

    angular.module('fdm.performedLegs', []);
}